<script setup lang="ts">

import type { WorkerDetail } from "@/modules/worker/types";

import WorkerJobs from "@/modules/worker/components/workerJobs/WorkerJobs.vue";
import WorkerKeywords from "@/modules/worker/components/workerKeywords/WorkerKeywords.vue";

interface QualificationsTabProps {
    worker: WorkerDetail;
    refreshWorker?: () => Promise<void>;
}

defineProps<QualificationsTabProps>();
</script>
<template>
    <div class="qualifications-tab">
        <section class="qualifications-tab__section">
            <WorkerJobs aside-layout :worker="worker" :refresh-worker="refreshWorker" :readonly="false" />
        </section>
        <div class="qualifications-tab__divider" role="presentation" />
        <section class="qualifications-tab__section">
            <WorkerKeywords aside-layout :worker="worker" :refresh-worker="refreshWorker" :readonly="false" />
        </section>
    </div>
</template>
<style scoped lang="scss">
.qualifications-tab {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-3xl, 24px);
    width: 100%;
    padding-bottom: var(--spacing-xl, 16px);
    box-sizing: border-box;

    &__section {
        padding: 0 var(--spacing-lg, 12px);
    }

    &__divider {
        height: 1px;
        width: 100%;
        flex-shrink: 0;
        background: var(--stroke-soft-200, #e2e4e9);
    }
}
</style>
